import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHomeIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M22.0519 7.42871L22.0519 7.42868L22.0465 7.42437L15.4965 2.18437L15.4954 2.18347C13.9462 0.948945 11.5572 0.931641 10.0088 2.17495C10.0086 2.17505 10.0085 2.17516 10.0084 2.17527L3.46025 7.42376C3.45999 7.42397 3.45973 7.42417 3.45947 7.42438C2.86434 7.89951 2.41695 8.5827 2.14473 9.29654C1.87254 10.0103 1.75187 10.8167 1.87841 11.5645C1.87846 11.5648 1.87851 11.5651 1.87856 11.5653L3.13826 19.1036L3.13881 19.1069C3.49017 21.1544 5.37023 22.75 7.44801 22.75H18.048C20.1074 22.75 22.0154 21.123 22.367 19.0983L22.3678 19.0936L23.6278 11.5536L23.6278 11.5536L23.6293 11.5441C23.7431 10.8041 23.617 10.0038 23.3461 9.29481C23.0752 8.58591 22.635 7.90406 22.0519 7.42871Z",
		fill: "white",
		stroke: "#A0A0A0",
		strokeWidth: 1.5
	})
});
export default SvgHomeIcon;
